import { FeedbackSummaryMessage, WebSocketMessage } from 'generated/graphql';

export const constructMarkdownFromFeedbackSummaryResponse = (
  messages: WebSocketMessage[],
  summaryMessageToMarkdownConverter: (
    summaryMessage: FeedbackSummaryMessage | undefined,
  ) => string,
) => {
  if (!messages.length) {
    return '';
  }

  const feedbackSummaryListMarkdown = messages.reduce(
    (markdownContent, { feedbackSummary }) => {
      return (
        markdownContent + summaryMessageToMarkdownConverter(feedbackSummary)
      );
    },
    '',
  );

  return feedbackSummaryListMarkdown;
};
